import React, { useEffect, useState } from "react";
import CommonModal from "../../UI/CommonModal/CommonModal";
import { Button, Input, message } from "antd";
import API from "../../Api/api";

export const ApplyCoupon = ({
  setIsModalOpen,
  isModalOpen,
  setCheckoutCoupon,
  checkoutCoupon,
  isCouponValidRef,
  removedSlpCouponRef,
  // setRemovedSlpCoupon,
  subsIdRef,
  clientIdRef,
}: {
  setIsModalOpen: any;
  isModalOpen: any;
  setCheckoutCoupon: (code: string) => void;
  checkoutCoupon: string;
  isCouponValidRef: React.MutableRefObject<boolean>;
  removedSlpCouponRef: React.MutableRefObject<boolean>;
  // setRemovedSlpCoupon:any
  subsIdRef: any;
  clientIdRef: any;
}) => {
  const [coupon, setCoupon] = useState(checkoutCoupon || "");

  const handleValidateCouponCode = async () => {
    if (!coupon) return;

    try {

      const response = await API.user.validateCoupon({
        subsId: subsIdRef.current,
        clientId: clientIdRef.current,
        accessToken: "sdfd", 
        couponCode: coupon,
      });

      if (response.data.valid) {
        message.success("Coupon applied successfully");

        isCouponValidRef.current = true;
        removedSlpCouponRef.current = true;
        // setRemovedSlpCoupon(true);

        setCheckoutCoupon(coupon);
        setIsModalOpen({ ...isModalOpen, applyCouponModal: false });
      } else {
        message.error("Invalid coupon");
        isCouponValidRef.current = false;
        removedSlpCouponRef.current = false;
        // setRemovedSlpCoupon(false);
      }
    } catch (error) {
      message.error("Something went wrong while validating coupon");
    } 
  };
  const handleCloseCouponModal = () => {
    // If no checkoutCoupon was applied, user just closed modal
    if (!checkoutCoupon) {
      removedSlpCouponRef.current = true;
      // setRemovedSlpCoupon(false);
    }
    setIsModalOpen({ ...isModalOpen, applyCouponModal: false });
  };
  

  useEffect(() => {
    if (isModalOpen?.applyCouponModal) {
      setCoupon(checkoutCoupon);
    }
  }, [isModalOpen?.applyCouponModal, checkoutCoupon]);
  return (
    <CommonModal
      isModalVisible={handleCloseCouponModal}
      visible={isModalOpen?.applyCouponModal}
      centered
    >
      <div style={{ padding: "20px", textAlign: "center" }}>
        <div
          style={{ fontSize: "18px", fontWeight: "bold", textAlign: "left" }}
        >
          Enter Coupon Code
        </div>
        <div
          style={{
            marginTop: "16px",
            backgroundColor: "#F5F5F5",
            padding: "5px",
            borderRadius: "4px",
          }}
        >
          <Input
            placeholder="Enter a Valid Coupon code"
            value={coupon}
            onChange={(e) => setCoupon(e.target.value)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              fontSize: "16px",
              color: "#000",
              height: "40px",
              outline: "none",
              boxShadow: "none",
              lineHeight:'normal'
            }}
          />
        </div>
        <Button
          style={{
            width: "100%",
            height: "45px",
            backgroundColor: coupon ? "black" : "#A6A6A6",
            color: "white",
            borderRadius: "4px",
            outline: "none",
            border: "none",
            fontWeight: 600,
            fontSize: "18px",
            cursor: coupon ? "pointer" : "not-allowed",
            marginTop: "20px",
          }}
          disabled={!coupon}
          onClick={handleValidateCouponCode}
        >
          Apply Coupon Code
        </Button>
      </div>
    </CommonModal>
  );
};
